type Options = {
  width?: string;
  height?: string;
  scrollbars?: 'no' | 'yes';
};

type ShareOption = 'facebook' | 'twitter' | 'reddit' | 'telegram' | 'wechat';

type Args = {
  options?: Options;
  url: string;
  shareTo: ShareOption;
  title?: string;
};

const getShareLink = ({ shareTo, url, title = '' }: Args) => {
  const SHARE_LIST: Record<ShareOption, string> = {
    facebook: `https://www.facebook.com/sharer/sharer.php?src=sp&u=${url}`,
    twitter: `https://twitter.com/intent/tweet?text=${title}&url=${url}`,
    reddit: `https://www.reddit.com/submit?url=${url}`,
    telegram: `https://telegram.me/share/url?url=${url}`,
    wechat: `https://www.addtoany.com/ext/wechat/share/#url=${url}`,
  };

  return SHARE_LIST[shareTo];
};

const shareBlogPost = ({ options, url, shareTo, title }: Args) => {
  const { width = '600', height = '400', scrollbars = 'no' } = options ?? {};
  return global?.open(
    getShareLink({ shareTo, url, title }),
    'pop',
    `width=${width}, height=${height}, scrollbars=${scrollbars}`,
  );
};

export default shareBlogPost;
